import React, { useState } from 'react';
import './About.css'
import user from '../../Asset/user.png'
import Skills from '../About/Skills/Skills'
import Experience from '../About/Experience/Experience'
import Education from '../About/Education/Education'


const About = () => {
    const [active, setActive] = useState("FirstCard")
    return (
        <div className='about'>
            <div className='container'>
                <div className="row">
                    <div className="about-col-1" data-aos="fade-down-right" data-aos-duration="2000">
                        <img src={user} alt="img" />
                    </div>
                    <div className="about-col-2" data-aos="flip-left" data-aos-duration="2000">
                        <h1 className='sub-title'>About Me</h1>
                        <p>Well, my name is Md.Yeasin Arafat. I'm 22 years old. I'm an innovative web developer while still
                            studying. I dad my 10+ projects coded primarily with javascript, react, node js, MongoDB,
                            Firebase, and some frameworks like daisy UI, tailwind, and bootstrap. And I’m interested in
                            learning much more about technology and programming languages like python, PHP, NextJS,
                            Vue js, etc. I will keep this learning process consistent.</p>
                        {/* Information section */}
                        <div className="tab-titles">
                            <p onClick={() => setActive("FirstCard")} className='tab-links active-link'>Skills</p>
                            <p onClick={() => setActive("SecondCard")} className='tab-links active-link'>Experience</p>
                            <p onClick={() => setActive("ThirdCard")} className='tab-links active-link'>Education</p>
                        </div>
                        <div>
                            {active === "FirstCard" && <Skills />}
                            {active === "SecondCard" && <Experience />}
                            {active === "ThirdCard" && <Education />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;